module.exports = __webpack_public_path__ + "img/dedicated-server.b8a80a2.webp";